<template>
  <div class="reporte-contactos">
    <v-card class="elevation-0" outlined>
      <v-tabs v-model="tab" xbackground-color="blue darken-2" >
        <v-tabs-slider color="green" ></v-tabs-slider>

        <v-tab class="">
          <v-icon left>mdi-chart-box-outline</v-icon>
          contactos registrados
        </v-tab>

        <v-tab class="">
          <v-icon left>mdi-chart-box-outline</v-icon>
          Aceptacion de terminos
        </v-tab>

        <v-tab class="">
          <v-icon left>mdi-chart-box-outline</v-icon>
          Reporte de inscripciones
        </v-tab>
      </v-tabs> 

      <v-card-text class="pa-0">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <ReporteContactosT1 />
          </v-tab-item>

          <v-tab-item>
            <ReporteContactosT2 />
          </v-tab-item>

          <v-tab-item>
            <reporteContactos_t3 />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
  import ReporteContactosT1 from './reporte-contactos_t1.vue';
  import ReporteContactosT2 from './reporte-contactos_t2_2.vue';
  import reporteContactos_t3 from './reporte-contactos_t3.vue';

  export default {
    components: {
      ReporteContactosT1,
      ReporteContactosT2,
      reporteContactos_t3,
    },
    data() {
      return {
        tab: 0,
      };
    },
  };
</script>

<style scoped>
.reporte-contactos {
  padding: 0 1em;
  margin: 0;
}
</style>
